import { Component, OnInit } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { CurrentOrderService } from '../services/current-order.service';
import { OrderCommandService } from '../data-service/order-command.service';
import { FavoriteOrderDetails } from '../models/my-orders/favorite-order-details.model';
import { StoreService } from 'projects/dop-core/src/public-api';
import { UserDetails } from '../models/user-details.model';
import { StoreKey } from 'src/app/core/store/ngrx-store.keys';
import { UserType } from '../enums/user-type.enum';

@Component({
  selector: 'app-fav-order',
  templateUrl: './fav-order-dialog.component.html',
  styleUrls: ['./fav-order-dialog.component.scss']
})
export class FavOrderDialogComponent implements OnInit {

  favOrderName: any;
  isMandatoryMissing = false;
  isShared = false;
  isInternalUser = true;

  constructor(
    public ref: DynamicDialogRef,
    private currentOrderService: CurrentOrderService,
    private orderCommandService: OrderCommandService,
    private storeService: StoreService
  ) { }

  async ngOnInit() {
    const userDetails = await this.storeService.Get<UserDetails>(StoreKey.UserDetails).toPromise();
    this.isInternalUser = userDetails.profile.userType.toString().toLowerCase() !== UserType[0].toString().toLowerCase();
    this.isShared = this.isInternalUser;
  }

  close() {
    this.ref.close();
  }

  submit() {
    const favOrderDetails: FavoriteOrderDetails = new FavoriteOrderDetails();
    favOrderDetails.name = this.favOrderName;
    favOrderDetails.orderCode = this.currentOrderService.currentOrder.OrderCode;
    favOrderDetails.isShared = this.isShared;
    this.orderCommandService.saveFavOrder(favOrderDetails).subscribe(() => {
      this.ref.close(true);
    });
  }

  isValid() {
    this.isMandatoryMissing = this.favOrderName !== undefined && this.favOrderName.length === 0;
  }
}
